@let info = withdrawalInfo();

<div class="details-container section">
  @if (info.method) {
    <iw-details-value
      label="withdrawal.details.accountName"
      [value]="'account.name' | translate: { currency: currencyFrom().symbol }"
    />

    <iw-details-value
      label="withdrawal.dialog.methodSelect.label"
      [value]="withdrawalMethod?.key | translate"
    />
  }

  @switch (info.method ?? withdrawalMethodId.Crypto) {
    @case (withdrawalMethodId.Paypal) {
      <iw-paypal-details [withdrawalInfo]="info" />
    }
    @case (withdrawalMethodId.CardPersonal) {
      <iw-card-personal-details [withdrawalInfo]="info" />
    }
    @case (withdrawalMethodId.ADVCash) {
      <iw-advcash-details [withdrawalInfo]="info" />
    }
    @case (withdrawalMethodId.BankTransferINR) {
      <iw-bank-transfer-inr-details [withdrawalInfo]="info" />
    }
    @case (withdrawalMethodId.Crypto) {
      <iw-crypto-details
        [withdrawalInfo]="info"
        [currencySymbol]="currencySymbol()"
      />
    }
  }

  @if (
    (info.method ?? withdrawalMethodId.Crypto) !== withdrawalMethodId.Crypto
  ) {
    <iw-details-value
      [value]="info.amount"
      [iconName]="currencySymbol()"
      label="withdrawal.details.finalAmount"
    />
  }

  @if (info.method === withdrawalMethodId.CODEOffice) {
    <iw-details-value
      [value]="info.rate || '-'"
      label="withdrawal.details.rate"
    />
  }
</div>
